export const ProfileErrors: Record<string, string> = {
  'Profile already exists': 'Já existe um Grupo de Usuário com este nome',
};
